import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import objectPath from 'object-path';
import store from '../store';

import en from '../locales/en';
import de from '../locales/de';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: objectPath.get(store.state, 'user.preferences.darkTheme', false),
    themes: {
      light: {
        primary: '#796efd',
        secondary: '#6355ff',
        accent: '#877dff',
        success: '#66BB6A',
        error: '#EF5350',
        warning: '#FFA726',
        info: '#42A5F5',
      },
      dark: {
        primary: '#796efd',
        secondary: '#6355ff',
        accent: '#877dff',
        success: '#66BB6A',
        error: '#EF5350',
        warning: '#FFA726',
        info: '#42A5F5',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { en, de },
    current: objectPath.get(store.state, 'user.preferences.language', 'en'),
  },
});
